module.exports = __webpack_public_path__ + "media/entities/1116-1ce8db30.png";